export default {
  apiVersion: 2,

  development: {
    accessToken: 'a3e0d599fa34c309694f20c02977939c',
    url: 'http://aktutaktu.dev.moya.is/_/moya/pilot/api',
  },
  production: {
    accessToken: 'a3e0d599fa34c309694f20c02977939c',
    url: 'https://www.aktutaktu.is/_/moya/pilot/api',
  },

};
